var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 36,
    fill: "#FC470E"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.552 35.03V22.047q0-9.228 4.368-14.581Q9.35 2.114 17.778.453v6.399Q11.503 8.82 9.35 13.619a11 11 0 0 0-.923 5.23h9.659v16.18zM46.94 6.851q-6.213 1.907-8.367 6.89-1.23 2.646-.984 5.107h9.659v16.18H29.714V22.048q0-9.351 4.491-14.643Q38.757 2.115 46.94.453z"
  })));
};
export default SvgQuote;